<template>
  <div class="header-nav">
    <img src="@/assets/logo.png" alt="" style="max-width: 100%;max-height: 100%; height: 100px;">
    <ul class="fontSize" @click.capture="togglePage" style="cursor: pointer;">
      <li :class="{active : activeIndex == 1}">首页</li>
      <li :class="{active : activeIndex == 2}">文章</li>
      <li :class="{active : activeIndex == 3}">留言</li>
      <li :class="{active : activeIndex == 4}">关于我</li>
    </ul>
  </div>
</template>

<script>
  export default{
    name:'HeaderNav',
    data(){
      return {
        activeIndex:1
      }
    },
    created() {
      this.activeIndex = sessionStorage.getItem('activeIndex') || 1
    },
    methods:{
      togglePage(e){
        switch(e.target.innerText){
          case '首页' :
            sessionStorage.setItem('activeIndex',1)
            this.activeIndex = 1
            this.$router.push({
              path:'/index'
            })
            break
          case '文章' :
           sessionStorage.setItem('activeIndex',2)
           this.activeIndex = 2
            this.$router.push({
              path:'/articles'
            })
            break
          case '留言' :
            sessionStorage.setItem('activeIndex',3)
            this.activeIndex = 3
            this.$router.push({
              path:'/leave-msg'
            })
            break
          case '关于我' :
            sessionStorage.setItem('activeIndex',4)
            this.activeIndex = 4
            this.$router.push({
              path:'/about'
            })
        }

      }
    }
  }
</script>

<style scoped="scoped" lang="scss">
  html,body{
    margin: 0;
    padding: 0;
  }
  .header-nav{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20%;
    height: 100px;
    background-color: #303133;
    .fontSize{
      font-size: 18px;
      font-weight: 700;
    }
    &>ul{
      display: inline-block;
      list-style: none;
      font-size: 18px;
      color: rgba(999, 999, 999, .4);
      li{
        display: inline-block;
        padding: 20px;

      }
    }
  }
  .active{
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/HeaderNav.vue